import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { UserAvatar } from "@/components/common/Bits";

export function ViewAsDialog({ open, onOpenChange, onPick }) {
  const { user } = useAuth();
  const { data: users = [] } = useQuery({ queryKey: ["users"], queryFn: () => api.get("/users").then((r) => r.data), enabled: open });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="view-as-dialog">
        <DialogHeader>
          <DialogTitle>View as another user</DialogTitle>
          <DialogDescription>Opens a read-only session that shows exactly what they see. Every view-as session is written to the audit log.</DialogDescription>
        </DialogHeader>
        <div className="max-h-80 divide-y divide-border overflow-auto border border-border" data-testid="view-as-user-select">
          {users.filter((u) => u.active && u.id !== user.id).map((u) => (
            <button key={u.id} onClick={() => { onOpenChange(false); onPick(u.id); }} className="row-hover flex w-full items-center gap-3 px-3 py-2 text-left" data-testid={`view-as-user-${u.id}`}>
              <UserAvatar name={u.name} src={u.avatar_url} size="sm" />
              <div className="flex-1">
                <div className="text-sm font-semibold">{u.name}</div>
                <div className="mono text-[11px] text-muted-foreground">{u.email}</div>
              </div>
              <span className="eyebrow">{u.view_only ? "view only" : `${u.permissions?.length || 0} capabilities`}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
